import React from 'react';
import CookieConsent from 'react-cookie-consent';
import 'url-search-params-polyfill';
import '../App.css';
import logo from '../assets/img/vucity-logo.png';

import Slideshow from '../components/Slideshow/Slideshow';
import TechnicalIssue from '../components/TechnicalError';
import { Header, Link, Logo } from '../components/UI';
import {
  Eighth,
  Fifth,
  First,
  Fourth,
  Second,
  Seventh,
  Sixth,
  Third,
} from '../components/exportImages';

const Blocked = () => (
  <div className="App">
    <div className="slide-show">
      <Slideshow slides={[First, Second, Third, Fourth, Fifth, Sixth, Seventh, Eighth]} />
    </div>
    <div className="content-area">
      <div className="app-header">
        <Logo url={null} imgSrc={logo} />
        <Header size="3">
          Welcome to VU.CITY Cloud
        </Header>
      </div>
      <TechnicalIssue>
        It is no longer possible to login via this page.<br />
        Please visit <Link href="https://dashboard.vu.city/dashboard/">the dashboard</Link> to access VU.CITY Cloud.
      </TechnicalIssue>
    </div>
    <CookieConsent
      debug
      style={{ background: 'var(--petrol-color)', alignItems: 'center' }}
      contentStyle={{ color: 'var(--white-color)' }}
      buttonStyle={{ fontSize: 'var(--large-font)' }}
    >
      In order to continually develop the platform, we gather user data to
      help us make optimal improvements to the platform. We never use your
      information for other purposes. We operate in full compliance with
      GDPR.
    </CookieConsent>
  </div>
);

export default Blocked;
